import { FaClipboardList, FaMotorcycle } from "react-icons/fa6";
import IventoryCard from "../../../common/helpers/inventory-card";
import { useNavigate } from "react-router-dom";
import Permission from "../../../common/components/auth/Permission";
import { MdHomeRepairService } from "react-icons/md";
import { CiStickyNote } from "react-icons/ci";
import { TbReportSearch } from "react-icons/tb";
import { BsClipboardCheck } from "react-icons/bs";
import { FaBox } from "react-icons/fa";

const InventorySection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full p-6">
      <header className="w-full pb-4 mb-6 border-b border-gray-200">
        <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
          📦 Módulo de Estoque{" "}
        </h2>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        <Permission permission="view:categories">
          <div
            onClick={() => navigate("/categorias")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<FaMotorcycle />}
              iconSize="70px"
              title="Categorias"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>

        <Permission permission="view:products">
          <div
            onClick={() => navigate("/produtos")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<FaClipboardList />}
              iconSize="70px"
              title="Catálago de Produtos"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>

        <Permission permission="view:works">
          <div
            onClick={() => navigate("/servicos")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<MdHomeRepairService />}
              iconSize="70px"
              title="Serviços"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>

        <Permission permission="view:stocks">
          <div
            onClick={() => navigate("/nfs")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<FaBox />}
              iconSize="70px"
              title="Estoque"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>

        <Permission permission="view:stocks">
          <div
            onClick={() => navigate("/retiradaDeEstoque")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<CiStickyNote />}
              iconSize="70px"
              title="Retirada de Estoque"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>
        <Permission permission="view:stocks">
          <a
            onClick={() => navigate("/controle-equipamentos")}
            className="hover:cursor-pointer col-span-1"
          >
            <IventoryCard
              icon={<TbReportSearch />}
              iconSize="70px"
              title="Ativo imobilizado"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </a>
        </Permission>
        <div>
          <a
            onClick={() => navigate("/stock-inventario")}
            className="hover:cursor-pointer col-span-1"
          >
            <IventoryCard
              icon={<BsClipboardCheck />}
              iconSize="70px"
              title="Inventário de estoque"
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InventorySection;
